
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...routes]",
      function () {
        return require("private-next-pages/[...routes].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...routes]"])
      });
    }
  